module.exports = __webpack_public_path__ + "static/media/es.6ed238ac.pdf";